import { action, computed, observable } from 'mobx';
import { IAutomationSidebarConfig } from '~/components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/automation-sidebar.types';
import TemplateSelectSideBarEmail from '~/components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/SideBars/TemplateSelectSideBarEmail';
import { IAutomationStepActionEmailBase } from '~/types/automation.types';
import { IAutomationEmailSettings, IVendorEmail } from '~/types/model.types';
import { AutomationStepActionBase } from '~/models/automations-steps/automations-step-actions/automation-step-action-base';
import { convertSmartFieldsToServerFormat } from '~/common/SmartFields/smart-fields.utils';
import { processEmailForEdit } from '~/utils/emails.utils';
import { sanitizeSubjectContent } from '~/components/OneComposer/SubjectRow/Subject.utils';

export abstract class AutomationStepActionEmailBase
    extends AutomationStepActionBase
    implements IAutomationStepActionEmailBase
{
    @observable email_template_id: string;
    @observable generic_email?: IVendorEmail;
    @observable attachment_count: number;
    @observable email_settings?: IAutomationEmailSettings;

    @computed
    get emailTemplate() {
        const { currCompany } = this.rootStore.companyStore;
        return currCompany?.getEmailTemplate(this.email_template_id);
    }

    @computed
    get genericEmail(): IVendorEmail {
        if (!this.generic_email) {
            return null;
        }

        const {
            userStore: { currUser }
        } = this.rootStore;

        const { html_body, ...email } = this.generic_email;
        return {
            ...email,
            html_body: processEmailForEdit({
                email: html_body,
                emailSignature: currUser?.emailSignature
            })
        };
    }

    // save this only in flow type?
    @computed
    get emailSettings(): IAutomationEmailSettings {
        return this.email_settings;
    }

    @computed
    get email(): IVendorEmail {
        return this.genericEmail
            ? {
                  ...this.genericEmail,
                  title: `${this.emailTemplate?.title} (modified)`
              }
            : this.emailTemplate;
    }

    @action
    selectEmailTemplate(templateId: string) {
        this.email_template_id = templateId;
        this.generic_email = undefined;
    }

    @action
    setGenericEmail({ html_body, subject, ...email }: IVendorEmail) {
        this.generic_email = {
            ...email,
            subject: convertSmartFieldsToServerFormat(
                sanitizeSubjectContent({ editorData: subject })
            ),
            html_body: convertSmartFieldsToServerFormat(html_body)
        };
    }

    @action
    setEmailSettings(state: IAutomationEmailSettings) {
        this.email_settings = state;
    }

    get emailSideBarConfig(): Pick<IAutomationSidebarConfig, 'selectEmail'> {
        return {
            selectEmail: {
                headerProps: { title: 'Email template' },
                component: TemplateSelectSideBarEmail,
                parent: 'main'
            }
        };
    }
}
